import { render, staticRenderFns } from "./OrdersCount.vue?vue&type=template&id=5933e4f2"
import script from "./OrdersCount.vue?vue&type=script&lang=ts"
export * from "./OrdersCount.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports